export default __webpack_public_path__ + "static/media/doc_student.61a7b0c0.svg";